import { useState } from 'react';
import { Navigate } from 'react-router';
import {
  CasRenderArrayAsRows,
  CasTable,
  CasErrorDisplay,
} from 'src/compass/shared/components';
import CasLoader from 'src/compass/shared/components/CasLoader/CasLoader';
import useRetrieve from 'src/compass/shared/hooks/reactQuery/useRetrieve';
import { useCurrentUserEmployee, CasYesNoSelect } from 'src/compass/application';

import ICasRenderCellProps from 'src/compass/shared/components/CasTable/ICasRenderCellProps';
import CustomerDialog from './CustomerDialog';
import { RenderRiskManagerName } from './RenderRiskManagerName';
import RenderHandoff from './RenderHandoff';
// import RenderRMCOfRecord from './RenderRMCOfRecord'; // RMC of Record column hidden for now
import { TOUCHPOINT_ENTITY } from './TouchpointsTab';
import customerSearchFilter from './_internal/customerSearchFilter';

export default function HandoffsTab() {
  const [dialogRowId, setDialogRowId] = useState<number | null>(null);
  const [reloadTable, setReloadTable] = useState<Date | null>(null);

  const { data, isLoading, isError, error } = useCurrentUserEmployee();
  const {
    data: riskManagerData,
    isLoading: riskManagerLoading,
    isError: isRiskManagerError,
    error: riskManagerError,
  } = useRetrieve({ url: 'CurrentUser/RiskManager' });

  if (isLoading || riskManagerLoading) return <CasLoader />;
  if (isError) return <CasErrorDisplay message={error.message} />;
  if (isRiskManagerError) return <CasErrorDisplay message={riskManagerError.message} />;
  // The tab is hidden outside the main office (CustomersPage); this covers a typed or
  // bookmarked URL, since the route itself is registered for everyone.
  if (!riskManagerData?.isMainOffice) return <Navigate to="/riskmanagement/customers" replace />;

  return (
    <>
      <CasTable
        entity={TOUCHPOINT_ENTITY}
        includeExport={false}
        refreshBtn
        update={reloadTable}
        additionalPayload={{ employeeId: data?.employeeId }}
        columns={[
          {
            field: 'name',
            render: (props: ICasRenderCellProps) => (
              <RenderRiskManagerName {...props} onClick={setDialogRowId} />
            ),
          },
          {
            field: 'contacts',
            sortable: false,
            render: CasRenderArrayAsRows,
          },
          // RMC of Record column hidden for now
          // {
          //   field: 'isRMCOfRecord',
          //   label: 'RMC of Record?',
          //   sortable: false,
          //   render: RenderRMCOfRecord,
          // },
          {
            field: 'handoff',
            label: 'Handoff',
            sortable: false,
            render: ({ row }: ICasRenderCellProps) => (
              <RenderHandoff
                id={row.id}
                handoffRequested={row.handoffRequested}
                handoffRequestedByName={row.handoffRequestedByName}
                handoffRequestedByCurrentUser={row.handoffRequestedByCurrentUser}
              />
            ),
          },
        ]}
        filters={[
          customerSearchFilter,
          {
            type: 'component',
            name: 'shared',
            label: 'Shared',
            initialValue: true,
            includeAllOption: true,
            component: CasYesNoSelect,
          },
          // RMC of Record filter hidden for now
          // {
          //   type: 'component',
          //   name: 'isRMCOfRecord',
          //   label: 'RMC of Record?',
          //   includeAllOption: true,
          //   component: CasYesNoSelect,
          // },
          {
            type: 'component',
            name: 'handoffRequested',
            label: 'Handoff Requested',
            includeAllOption: true,
            component: CasYesNoSelect,
          },
        ]}
      />
      {dialogRowId && (
        <CustomerDialog
          id={dialogRowId}
          onClose={(dataUpdated?: boolean) => {
            setDialogRowId(null);
            if (dataUpdated) setReloadTable(new Date());
          }}
        />
      )}
    </>
  );
}
